import { Partner } from "./partner.model";

export class User {

    userId!: number;
    first!: string;
    last!: string;
    email!: string;
    access!: number;
    phone!: string;
    password?: string;

    partner?: Partner;

    token!: string;

    created!: string;
    updated!: string;
    disabled!: string;

    public load(data: any): User {
        Object.assign(this, data);

        this.partner = new Partner().load(data.partner);

        return this;
    }
}
